import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './ScrollableTabs.css'; // Import the CSS file

const TRANSLATE_AMOUNT = 150;

const ScrollableTabs = ({ categories = [], selectedCategory, onSelect, documentsType }) => {
    const containerRef = useRef(null);
    const [translate, setTranslate] = useState(0);
    const [isLeftVisible, setIsLeftVisible] = useState(false);
    const [isRightVisible, setIsRightVisible] = useState(false);
    // const dummyjson = {
    //     category1: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category2: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category3: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category4: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category5: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category6: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //     category7: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category8: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category9: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category10: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category11: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category12: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    //      category13: [
    //        { data: 1,
    //         id: 2222}
    //     ],
    // }
    useEffect(() => {
        const checkVisibility = () => {
            if (containerRef.current) {
                const container = containerRef.current;
                setIsLeftVisible(translate > 0);
                setIsRightVisible(translate + container.clientWidth < container.scrollWidth);
            }
        };
        console.log(categories, 'categories')
        checkVisibility();
        window.addEventListener('resize', checkVisibility);
        return () => window.removeEventListener('resize', checkVisibility);
    }, [translate, categories]);

    return (
        <div ref={containerRef} className="scroll-container mb-3">
            <div
                className="scroll-inner"
                style={{ transform: `translateX(-${translate}px)` }}
            >
                {Object.keys(categories).map((category) => (
                    <button
                        key={category}
                        onClick={() => onSelect(category)}
                        className={`tab-button ${selectedCategory === category ? 'active' : ''}`}
                    >
                        {documentsType == 'files' ? category : categories[category]}
                    </button>
                ))}
            </div>

            {isLeftVisible && (
                <div className="scroll-left-arrow">
                    <button
                        className="arrow-button left"
                        onClick={() =>
                            setTranslate((prev) => Math.max(0, prev - TRANSLATE_AMOUNT))
                        }
                    >
                        <ChevronLeft />
                    </button>
                </div>
            )}

            {isRightVisible && (
                <div className="scroll-right-arrow">
                    <button
                        className="arrow-button right"
                        onClick={() => {
                            const container = containerRef.current;
                            if (!container) return;
                            const maxTranslate = container.scrollWidth - container.clientWidth;
                            setTranslate((prev) =>
                                Math.min(prev + TRANSLATE_AMOUNT, maxTranslate)
                            );
                        }}
                    >
                        <ChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ScrollableTabs;

